module.exports = __webpack_public_path__ + "img/66.ea97d667.png";